import React from 'react';
import s from './s.module.less';
import commonS from 'styles/common.module.less';
import { useNavigate } from 'react-router-dom';
import SettingArrow from 'assets/setting/Chevron right.svg';
import ChannelsIcon from 'assets/prospects/channel.svg';
import { PATH } from 'constants/path';
import MedicationSettings from 'components/ManageSubscription/components/MedicationSettings';
import useProviderHomeInfo from 'hooks/useProviderHomeInfo';
import AIChat from 'components/AIChat';
import { EAIChatPageId } from 'types/ai';

const Page = () => {
    const navigate = useNavigate();
    const [homeInfo] = useProviderHomeInfo();

    return (
        <div className={`${s.wrap} px-6 py-12`}>
            <div className={s.nav}>
                <div className="flex">
                    <img className="w-5 h-5" style={{ marginRight: '10px' }} src={ChannelsIcon} />
                    <div className="text-gray-500 font-medium text-sm cursor-pointer" onClick={() => navigate(`${PATH.DASHBOARD}/${PATH.MARKETING}`)}>Marketing</div>
                </div>
                <img className={s.arrow} src={SettingArrow} alt="" />
                <div className="font-medium" style={{ color: '#00816B' }}>Settings</div>
            </div>
            <MedicationSettings isKlarityHealthJoined={homeInfo?.klarityListed} theme="marketing" />
            <div className={commonS.chatWrap}>
                <AIChat
                    pageId={EAIChatPageId.PROVIDER_MARKETING_SETTING}
                    defaultShow={false}
                    makeFix={false}
                />
            </div>
        </div>
    );
};

export default Page;
